export const joinClassNames = (a) => Object.values(a).join(' ')
